<template lang="pug">
  main#main

    template(v-if="isMobile")

      transition(
        name="fade"
        mode="out-in"
        @before-enter="onBeforeEnter"
        @leave="onLeave"
        @after-leave="onAfterLeave"
      )
        router-view

    template(v-else)
      DesktopPage

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DesktopPage from '../views/DesktopPage.vue';

export default {
  name: 'Main',
  props: {
  },
  computed: {
    ...mapState(['isMobile']),
  },
  data: () => {
    return {
    }
  },
  watch: {
    $route(to, from) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      let currentTarget, nextTarget;
      
      if (from.path === to.path && to.path === '/') {
        // 同頁切換
      } else {
        // 不同頁切換
        const currentName = from.path === '/' ? 'home' : from.path.replace('/', '');
        currentTarget = document.querySelector(`.page-${currentName}`)
      }
      
      if (currentTarget) {
        currentTarget.style.position = 'fixed';
        currentTarget.style.top = `${scrollTop * -1}px`;
      }

      // window.scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth'
      // });
    },
  },
  methods: {
    ...mapMutations([]),
    onBeforeEnter() {},
    onLeave() {
      // const sections = document.querySelectorAll('.section')
      // sections[1].classList.add('play')
    },
    onAfterLeave() {},
  },
  mounted() {
  },
  components: {
    DesktopPage,
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/common/';

#main {

  position: relative;
  width: 100%;
  height: auto;
  min-height: calc(var(--vh, 1vh) * 100);
  color: #fff;
  font-weight: 400;
  margin: 0 auto;
  z-index: 2;

  .page {
    width: 100%;
    height: auto;
    min-height: calc(var(--vh, 1vh) * 100);
    @include desktop {
      &:not(.page-desktop) {
        display: none;
      }
    }
  }

}

.section {
  // position: relative;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: vw(1250);
  @include desktop {
  }
}

.section__inner {
  width: vw(750);
  height: vw(1250);
  @include desktop {
  }
}

</style>
